module.exports = __webpack_public_path__ + "static/media/sz.8f0d2436.svg";